import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiDivider, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
const queryString = require('query-string');
import elevateByEase from '~/assets/images/elevate-by-ease.png';

interface RouteParams {
  status: string;
}

interface Props {}

const messageContent = {
  SUBMITTED: {
    subject: 'Your Medical Form has been successfully submitted.',
    content: 'If you require help with your answers, please reach out to hello@tryelevate.sg.',
  },
  EXPIRED: {
    subject: 'The link you followed has expired.',
    content: 'Please contact us at hello@tryelevate.sg for a new medical form.',
  },
};

const MDQ2QuestionnaireInvalidScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const location = window.location;
  const query: RouteParams = queryString.parse(location.search);
  const {methodKey, medicalUUID, answerOrder, collectedData} = mdq;
  const {addMessage} = useNotification(dispatch);
  const isSubmitted = query.status === 'submitted';

  const renderParseText = (text: string) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const parts = text.split(emailRegex);

    if (parts.length === 2) {
      const email = text.match(emailRegex);
      return (
        <>
          {parts[0]}
          <a href={`mailto:${email}`} style={{color: 'blue'}}>
            {email}
          </a>
          {parts[1]}
        </>
      );
    }

    return text;
  };

  return (
    <UiQuestionnaireLayout
      showHeader={false}
      showBackButton={false}
      isFirstScreen
      pageTitle="MDQ2 - Expired or Submitted"
      maxW="700px"
    >
      <Col alignItems="center" justifyContent="center" textAlign="center" mt={6} mb={1} flexGrow={1}>
        <Col
          borderRadius={12}
          boxShadow="0px 0px 10px 6px rgba(0, 0, 0, 0.05)"
          p={6}
          w="100%"
          alignItems="center"
          justifyContent="center"
        >
          <UiImage url={elevateByEase} height="4rem" width="6.25rem" />
          <UiText fontSize="lg" fontWeight="bold" mb={6} mt={6}>
            {isSubmitted ? messageContent.SUBMITTED.subject : messageContent.EXPIRED.subject}
          </UiText>
          <UiText fontSize="sm" fontWeight="500" color="trueBlack" mb={6}>
            {renderParseText(isSubmitted ? messageContent.SUBMITTED.content : messageContent.EXPIRED.content)}
          </UiText>
          <Row w="100%" alignItems="center" justifyContent="center">
            <UiDivider w={5} borderColor="trueBlack" opacity={1} />
            <UiText fontWeight="500" mx={1}>
              The Elevate team
            </UiText>
            <UiDivider w={5} borderColor="trueBlack" opacity={1} />
          </Row>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQ2QuestionnaireInvalidScreen;
